import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AccountBlockGuard } from '../account/guard/account-block-guard';
import { PermissionGuard } from '../shared/guards/permission-guard';
import { VersionGuard } from '../shared/guards/version-guard';

import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { PermissionLevel } from '../shared/permission/permission';
import { RoutePaths } from '../shared/navigation/route-paths';
import { TasksOverviewComponent } from './tasks-overview/tasks-overview.component';

const tasksRoutes: Array<DynamicRoute> = [
  {
    path: RoutePaths.EMPTY,
    component: TasksOverviewComponent,
    canActivate: [VersionGuard, PermissionGuard, AccountBlockGuard],
    data: {
      permissionLevel: PermissionLevel.MANAGER
    }
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(tasksRoutes)]
})
export class TasksRoutingModule {}
